import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { Form } from 'react-final-form';
import FileSecurity from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/DataRoomDocumentDrawers/ManageFileAccess/components/FileSecurity';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { getPayloadBulkFileSettings } from 'router/subrouters/DataRoom/utils';
import { BulkAvailabilityFileSettings } from 'router/subrouters/DataRoom/models/DataRoomBulk';
import RfiContext from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';

import './DocumentsRfiSecurity.styles.scss';

type DocumentsRfiSecurityProps = {
  className?: string;
  dataRoomRfiId: string;
  fileSettingsInitialValues: BulkAvailabilityFileSettings;
};

const DocumentsRfiSecurity: React.FC<DocumentsRfiSecurityProps> = (props) => {
  const { className, dataRoomRfiId, fileSettingsInitialValues } = props;

  const { popSuccess, popServerError } = useContext(PopNotificationsContext);
  const { updateRfi } = useContext(RfiContext);

  const classes = classNames('documents-rfi-security', className);

  const { t } = useTranslation();

  const onSubmit = useCallback(
    async (values) => {
      const result = getPayloadBulkFileSettings(values);

      try {
        const { data } = await dataRoomApi.rfi.patchRfi(dataRoomRfiId, result);

        updateRfi(data);
        popSuccess(t('succesfullyUpdatedRFISecurity'));
      } catch (e) {
        popServerError(e);
      }
    },
    [dataRoomRfiId, popServerError, popSuccess, t, updateRfi],
  );

  return (
    <div className={classes}>
      <Form
        keepDirtyOnReinitialize
        initialValues={fileSettingsInitialValues}
        onSubmit={onSubmit}
        render={({ invalid, pristine, submitting, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FileSecurity
              defaultOpen={false}
              description={t('rfiFileSecurityDescription')}
            >
              <div className="actions">
                <Button
                  type="submit"
                  disabled={invalid || pristine || submitting}
                >
                  {t('save')}
                </Button>
              </div>
            </FileSecurity>
          </form>
        )}
      />
    </div>
  );
};

export default DocumentsRfiSecurity;
